export const timeOffDisabledTime = () => {
  return {
    disabledHours: () => [0, 1, 2, 3, 4, 5, 6, 7, 19, 20, 21, 22, 23, 24],
    disabledMinutes: (selectedHour: number) =>
      selectedHour === 18 ? [10, 20, 30, 40, 50] : [],
  }
}
